<template>
    <div>
        <div class="top-nav">
            <router-link @click="go" to="" class="icon icon-arrow-left"></router-link>
        </div>
        <router-view></router-view>
        <Feedback></Feedback>
    </div>
</template>
<style lang="less" scoped>
    @import "~assets/less/icon.less";
    .top-nav{
       padding:10px 50px;
       border-bottom:2px solid #f1f1f1;
       overflow: hidden;
       a.icon{
         float:left;
       }
    }
</style>
<script>
import Feedback from '../components/feedback.vue'
export default {
    components:{
        Feedback
    },
    methods:{
        go () {
            this.$router.go(-1)
        }
    }
}
</script>